import { ValidatorService } from './../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { parse } from 'url';
declare var $;

@Component({
  selector: 'app-touchspin-v2',
  templateUrl: './touchspin-v2.component.html',
  styleUrls: ['./touchspin-v2.component.scss']
})
export class TouchspinV2Component implements OnInit {

  @Input() public min: any = 0;
  @Input() public max: any = 100;
  @Input() public symbol: any = '%';
  @Input() public quantity: any = '';
  @Input() public enabled: any = true;
  @Input() public decimals: any = 2;
  noValid: any;

  @Output() setQuantity: EventEmitter<number> = new EventEmitter();

  constructor(private validatorService: ValidatorService) { }

  ngOnInit() {
  }

  isEnabled() {
    return (this.enabled === true);
  }
  press($event) {
    const key = $event.key;
    const quantity = this.quantity.toString().concat(key);
    if(quantity > this.max){
      return false;
    }
    if (key != 'Backspace' && !this.validatorService.maxDecimals(quantity, this.decimals)) {
        return false;
    }
    if (key == '.' && !this.validatorService.required(this.quantity)) {
        return false;
    }
    if (key != 'Backspace' && key !== '.' && !this.validatorService.numeric(key)) {
        return false;
    }
    if (this.quantity == 0) {
        this.quantity = '';
    }
  }

  emit() {
      this.noEmpty();
      this.setQuantity.emit(this.quantity);
  }

  subtract() {
    if (this.quantity > this.min || this.quantity > 1) {
      this.quantity --;
      this.emit();
    }
  }
  noEmpty() {
      if (!this.validatorService.required(this.quantity)) {
        this.quantity = 0;
      }
  }

  add() {
    if (this.quantity < this.max) {
      this.quantity ++;
      this.emit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/touchspin-v2/touchspin-v2.component.ts